import React from 'react';
import DateTimeUtility from '../../../common/utility/DateTimeUtility';

/**
 * リリース情報
 */
export default function MusicAlbumInfoReleaseTitleView({
  musicAlbum,
} : {
  musicAlbum: {
    title: string,
    title_kana: string,
    title_en: string,
    image_url: string,
    genre: string,
    tunecore_completed_date: string|null,
    music_album_artists: {
      name: string,
      name_kana: string,
      name_en: string,
    }[],
    music_album_tracks: {
      music: {
        title: string,
        title_kana: string,
        title_en: string,
      },
    }[],
  },
}) {
  const title = musicAlbum.music_album_tracks.length === 1 ? musicAlbum.music_album_tracks[0].music.title : musicAlbum.title;
  const titleKana = musicAlbum.music_album_tracks.length === 1 ? musicAlbum.music_album_tracks[0].music.title_kana : musicAlbum.title_en;
  const titleEn = musicAlbum.music_album_tracks.length === 1 ? musicAlbum.music_album_tracks[0].music.title_en : musicAlbum.title_en;
  const compoundArtistName = musicAlbum.music_album_artists.map((musicAlbumArtist) => musicAlbumArtist.name).join(' & ');
  const compoundArtistNameKana = musicAlbum.music_album_artists.map((musicAlbumArtist) => musicAlbumArtist.name_kana).join(' & ');
  const compoundArtistNameEn = musicAlbum.music_album_artists.map((musicAlbumArtist) => musicAlbumArtist.name_en).join(' & ');

  return (
    <div className="music_list_top">
      <img src={musicAlbum.image_url} alt="" />
      <ul>
        <li>
          <b className="ttl">リリースタイトル：</b>
          <b>{title}</b>
          <p>
            {titleKana}
            /
            {titleEn}
          </p>
        </li>
        <li>
          <b className="ttl">リリースアーティスト名：</b>
          <b>{compoundArtistName}</b>
          <p>{`${compoundArtistNameKana}/${compoundArtistNameEn}`}</p>
        </li>
        <li>
          <b className="ttl">ジャンル：</b>
          {musicAlbum.genre}
        </li>
        {musicAlbum.tunecore_completed_date !== null && (
          <li className="d_data">
            <b className="ttl">配信開始日：</b>
            {DateTimeUtility.format(musicAlbum.tunecore_completed_date, 'Y/n/j')}
          </li>
        )}
      </ul>
    </div>
  );
}
